var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('video-card');
import { breakpoints, theme } from '@shapeable/theme';
import { VideoImage } from './video-image';
import { Content } from '../elements/content';
export var VideoBasicCardDefaultProps = {
  padInfo: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    line-height: 1.35em;\n\n  "], ["\n    line-height: 1.35em;\n\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.padInfo && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(4));
  })
});
var TitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: ", " 0 ", " 0;\n    font-size: 1.0em;\n    line-height: 1.3em;\n    color: ", ";\n    font-weight: 500;\n  "], ["\n    margin: ", " 0 ", " 0;\n    font-size: 1.0em;\n    line-height: 1.3em;\n    color: ", ";\n    font-weight: 500;\n  "])), theme.UNIT(3), theme.UNIT(2), theme.COLOR('dark'))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(VideoImage)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled(Content)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var VideoBasicCard = function VideoBasicCard(props) {
  var className = props.className,
      entity = props.entity,
      padInfo = props.padInfo,
      preBody = props.preBody,
      imageProps = __rest(props, ["className", "entity", "padInfo", "preBody"]);

  var name = entity.name,
      description = entity.description;
  var hasDescription = description && description.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, __assign({
    entity: entity
  }, imageProps)), preBody, React.createElement(My.Body, {
    padInfo: padInfo
  }, React.createElement(My.Title, null, name), hasDescription && React.createElement(My.Description, {
    html: description.text
  })));
};
VideoBasicCard.defaultProps = VideoBasicCardDefaultProps;
VideoBasicCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;